import { abujaDc, airtel, bitcoin, bnb, doge, ekoDc, ethh, etisalat, glo, ibadanDc, ikejaDc, josDc, kadunaDc, kanoDC, mtn, phDc, pol, shiba, sol, trx, usdc, usdt } from "../assets/images";

export const coins = [
        {
            id: 1,
            name: "Bitcoin",
            abbr: "BTC",
            logo: bitcoin,
            networks: [
                {
                    id: 12,
                    name: "BTC",
                     withdrawalFee: 0.0001,
        minimumWithdrawal: 0.00022,
                }
            ]
        },
        {
            id: 2,
            name: "Tether",
            abbr: "USDT",
            logo: usdt,
            networks: [
                {
                    id: 21,
                    name: "BSC",
                       withdrawalFee: 0.5,
        minimumWithdrawal: 10.5,
                },
                {
                    id: 22,
                    name: "ETH",
                       withdrawalFee: 2,
        minimumWithdrawal: 20,
                },
                {
                    id: 23,
                    name: "TRX",
                     withdrawalFee: 2,
        minimumWithdrawal: 15,
                },
                {
                    id: 24,
                    name: "SOL",
                     withdrawalFee: 1,
        minimumWithdrawal: 12,
                },
            ]
        },
        {
            id: 3,
            name: "Ethereum",
            abbr: "ETH",
            logo: ethh,
            networks: [
                {
                    id: 31,
                    name: "BSC",
                  withdrawalFee: 0.00035,
        minimumWithdrawal: 0.00013,
                },
                {
                    id: 32,
                    name: "ETH",
                            withdrawalFee: 0.00285,
        minimumWithdrawal: 0.00485,
                },
                
            ]
        },
        {
            id: 4,
            name: "Doge",
            abbr: "DOGE",
            logo: doge,
            networks: [
                {
                    id: 41,
                    name: "DOGE",
                       withdrawalFee: 8,
        minimumWithdrawal: 80,
                },
                
            ]
        },
        {
            id: 5,
            name: "Shiba Inu",
            abbr: "SHIB",
            logo: shiba,
            networks: [
                {
                    id: 51,
                    name: "BSC",
                    withdrawalFee: 48610,
        minimumWithdrawal: 23000,
                },
                {
                    id: 52,
                    name: "ETH",
                   withdrawalFee: 420000,
        minimumWithdrawal: 636554,
                },
               
            ]
        },
          {
            id: 6,
            name: "Solana",
            abbr: "SOL",
            logo: sol,
        
            networks: [
                {
                    id: 61,
                    name: "SOL",
                        withdrawalFee: 0.015,
            minimumWithdrawal: 0.1,
                },
                
               
            ]
        },
        {
            id: 7,
            name: "Tron",
            abbr: "TRX",
            logo: trx,
            
            networks: [
                {
                    id: 71,
                    name: "TRX",
                    withdrawalFee: 5,
                    minimumWithdrawal: 35,
                },
                
            
                
               
            ]
        },
        {
            id: 8,
            name: "USD Circle",
            abbr: "USDC",
            logo: usdc,
            
            networks: [
                {
                    id: 81,
                    name: "BSC",
                    withdrawalFee: 0.5,
                    minimumWithdrawal: 10,
                },
                {
                    id: 82,
                    name: "ETH",
                    withdrawalFee: 2,
        minimumWithdrawal: 20,
                },
                {
                    id: 83,
                    name: "SOL",
                    withdrawalFee: 3,
                    minimumWithdrawal: 10,
                },
            ]
        },
        {
            id: 9,
            name: "BNB",
            abbr: "BNB",
            logo: bnb,
            networks: [
                {
                    id: 91,
                    name: "BSC",
                    withdrawalFee: 0.001,
                    minimumWithdrawal: 0.01,
                },
                {
                    id: 92,
                    name: "ETH",
                    withdrawalFee: 0.002,
                    minimumWithdrawal: 0.012,
                },
            ]
        },
        {
            id: 10,
            name: "Polygon",
            abbr: "POL",
            logo: pol,
            networks: [
                {
                    id: 101,
                    name: "ETH",
                    withdrawalFee: 12,
                    minimumWithdrawal: 20,
                },
                {
                    id: 102,
                    name: "MATIC",
                    withdrawalFee: 0.4,
                    minimumWithdrawal: 21,
                },
                {
                    id: 103,
                    name: "BSC",
                    withdrawalFee: 1.4,
                    minimumWithdrawal: 0.2,
                },
            ]
        },
    ]
export const depCoins =  [
        {
            id: 1,
            name: "Bitcoin",
            abbr: "BTC",
            logo: bitcoin,
            networks: [
                {
                    id: 12,
                    name: "BTC",
                     withdrawalFee: 0.0001,
        minimumWithdrawal: 0.0003,
                }
            ]
        },
        {
            id: 2,
            name: "Tether",
            abbr: "USDT",
            logo: usdt,
            networks: [
                {
                    id: 21,
                    name: "BSC",
                       withdrawalFee: 0.5,
        minimumWithdrawal: 10.5,
                },
                {
                    id: 22,
                    name: "ETH",
                       withdrawalFee: 5,
        minimumWithdrawal: 20,
                },
                {
                    id: 23,
                    name: "TRX",
                     withdrawalFee: 2,
        minimumWithdrawal: 15,
                },
                {
                    id: 24,
                    name: "SOL",
                     withdrawalFee: 1,
        minimumWithdrawal: 12,
                },

            ]
        },
        {
            id: 3,
            name: "Ethereum",
            abbr: "ETH",
            logo: ethh,
            networks: [
                {
                    id: 31,
                    name: "BSC",
                  withdrawalFee: 0.00035,
        minimumWithdrawal: 0.00013,
                },
                {
                    id: 32,
                    name: "ETH",
                            withdrawalFee: 0.005,
        minimumWithdrawal: 0.014,
                },
                
            ]
        },
        {
            id: 4,
            name: "Doge",
            abbr: "DOGE",
            logo: doge,
            networks: [
                {
                    id: 41,
                    name: "DOGE",
                       withdrawalFee: 8,
        minimumWithdrawal: 80,
                },
                
            ]
        },
        {
            id: 5,
            name: "Shiba Inu",
            abbr: "SHIB",
            logo: shiba,
            networks: [
                {
                    id: 51,
                    name: "BSC",
                    withdrawalFee: 48610,
        minimumWithdrawal: 23000,
                },
                {
                    id: 52,
                    name: "ETH",
                   withdrawalFee: 420000,
        minimumWithdrawal: 636554,
                },
               
            ]
        },
          {
            id: 6,
            name: "Solana",
            abbr: "SOL",
            logo: sol,
        
            networks: [
                {
                    id: 61,
                    name: "SOL",
                        withdrawalFee: 0.015,
            minimumWithdrawal: 0.1,
                },
                
               
            ]
        },
        {
            id: 7,
            name: "Tron",
            abbr: "TRX",
            logo: trx,
            
            networks: [
                {
                    id: 71,
                    name: "TRX",
                    withdrawalFee: 5,
                    minimumWithdrawal: 35,
                },
                
            
                
               
            ]
        },
        {
            id: 8,
            name: "USD Circle",
            abbr: "USDC",
            logo: usdc,
            
            networks: [
                {
                    id: 81,
                    name: "BSC",
                    withdrawalFee: 0.5,
                    minimumWithdrawal: 10,
                },
                    {
                        id: 82,
                        name: "ETH",
                        withdrawalFee: 3,
                        minimumWithdrawal: 25,
                    },
                    {
                        id: 83,
                        name: "SOL",
                        withdrawalFee: 3,
                        minimumWithdrawal: 10,
                    },
            ]
        },
        {
            id: 9,
            name: "BNB",
            abbr: "BNB",
            logo: bnb,
            networks: [
                {
                    id: 91,
                    name: "BSC",
                    withdrawalFee: 0,
                    minimumWithdrawal: 0,
                },
                {
                    id: 92,
                    name: "ETH",
                    withdrawalFee: 0,
                    minimumWithdrawal: 0,
                },
            ]
        },
        {
            id: 10,
            name: "Polygon",
            abbr: "POL",
            logo: pol,
            networks: [
                {
                    id: 101,
                    name: "ETH",
                    withdrawalFee: 12,
                    minimumWithdrawal: 20,
                },
                {
                    id: 102,
                    name: "MATIC",
                    withdrawalFee: 0.4,
                    minimumWithdrawal: 21,
                },
                {
                    id: 103,
                    name: "BSC",
                    withdrawalFee: 1.4,
                    minimumWithdrawal: 0.2,
                },
            ]
        },
    ]



    
export const utils =  [
        {
            id: 1,
            name: "MTN",
            abbr: "mtn",
            logo: mtn,
           
        },
        {
            id: 2,
            name: "Airtel",
            abbr: "airtel",
            logo: airtel,
           
        },
        {
            id: 3,
            name: "Glo",
            abbr: "glo",
            logo: glo,

        },
        {
            // The 9mobile asset was already imported but never listed here, so
            // 9mobile airtime/data fell back to the generic phone icon.
            id: 4,
            name: "9mobile",
            abbr: "9mobile",
            logo: etisalat,

        },


    ]
export const electricUtils =  [
        {
            id: 1,
            name: "Abuja Electricity Distribution Company (AEDC)",
            serviceId: "abuja-electric",
            logo: abujaDc,
           
        },
       
        {
            id: 2,
            name: "Eko Electricity Distribution Company (EKEDC)",
            serviceId: "eko-electric",
            logo: ekoDc,
           
        },
        {
            id: 3,
            name: "Ibadan Electricity Distribution Company (IBEDC)",
            serviceId: "ibadan-electric",
            logo: ibadanDc,
           
        },
        {
            id: 4,
            name: "Ikeja Electricity Distribution Company (IKEDC)",
            serviceId: "ikeja-electric",
            logo: ikejaDc,
           
        },
        {
            id: 5,
            name: "Jos Electricity Distribution Company (JEDplc)",
            serviceId: "jos-electric",
            logo: josDc,
           
        },
        {
            id: 6,
            name: "Kaduna Electricity Distribution Company (KAEDCO)",
            serviceId: "kaduna-electric",
            logo: kadunaDc,
           
        },
        {
            id: 7,
            name: "Kano Electricity Distribution Company (KEDCO)",
            serviceId: "kano-electric",
            logo: kanoDC,
           
        },
        {
            id: 8,
            name: "Port Harcourt Electricity Distribution Company (PHED)",
            serviceId: "portharcourt-electric",
            logo: phDc,
           
        },
       
       
    ]

export const confettiPieces = Array.from({ length: 28 }, (_, i) => {
  const colors = ["#5CC3FF", "#0B75C2", "#F8C537", "#FF7A59"];

  return {
    left: `${50 + (Math.random() * 60 - 30)}%`,
    delay: `${i * 0.06}s`,
    color: colors[i % colors.length],
    drift: `${Math.random() * 120 - 60}px`,
    duration: `${2.6 + Math.random()}s`,
  };
});

type NetworkName = "BSC" | "ETH" | "TRX" | "BTC" | "SOL" | "DOGE" | "MATIC" | "POL" | "POLYGON";

export const NETWORK_LABEL_MAP: Record<NetworkName, string> = {
  BSC: "BEP-20",
  ETH: "ERC-20",
  TRX: "TRC-20",
  BTC: "BTC",
  SOL: "SOL",
  DOGE: "DOGE",
  MATIC: "Polygon",
  POL: "Polygon",
  POLYGON: "Polygon",
};

export const getNetworkLabel = (network: string) =>
  NETWORK_LABEL_MAP[network as NetworkName] ?? network;

// Source of Income Options
export const SOURCE_OF_INCOME_OPTIONS = [
  { label: "Salary / Employment (Private Sector)", value: "salary_private" },
  { label: "Salary / Employment (Public Sector)", value: "salary_public" },
  { label: "Self-Employed", value: "self_employed" },
  { label: "Business Owner", value: "business_owner" },
  { label: "Freelancer / Contractor", value: "freelancer" },
  { label: "Digital / Online Business", value: "digital_business" },
  { label: "Investments (Stocks, Crypto, Bonds, etc.)", value: "investments" },
  { label: "Rental Income", value: "rental_income" },
  { label: "Agriculture / Farming", value: "agriculture" },
  { label: "Artisan / Skilled Trade", value: "artisan" },
  { label: "Commission / Sales Income", value: "commission_income" },
  { label: "Pension", value: "pension" },
  { label: "Government Benefits / Grants", value: "government_benefits" },
  { label: "Family Support / Allowance", value: "family_support" },
  { label: "Remittance from Abroad", value: "remittance" },
  { label: "Student (Allowance / Scholarship)", value: "student" },
  { label: "Unemployed", value: "unemployed" },
  { label: "Other", value: "other" },
];

// Monthly Income Range (NGN)
export const MONTHLY_INCOME_RANGE_OPTIONS = [
  { label: "Below ₦50,000", value: "below_50000" },
  { label: "₦50,000 – ₦100,000", value: "50000_100000" },
  { label: "₦100,001 – ₦250,000", value: "100001_250000" },
  { label: "₦250,001 – ₦500,000", value: "250001_500000" },
  { label: "₦500,001 – ₦1,000,000", value: "500001_1000000" },
  { label: "₦1,000,001 – ₦2,500,000", value: "1000001_2500000" },
  { label: "₦2,500,001 – ₦5,000,000", value: "2500001_5000000" },
  { label: "₦5,000,001 – ₦10,000,000", value: "5000001_10000000" },
  { label: "Above ₦10,000,000", value: "above_10000000" },
];


// Fixed Nomba NIP transfer fee (₦) charged on top of every NGN wallet withdrawal.
// Confirmed by backend — see NAIRA_WALLET_NOMBA.md §1.
export const NAIRA_WITHDRAWAL_FEE = 50;

// Kill switch for the Naira wallet (Nomba). Off while the wallet is still being
// negotiated: utilities went live first, paid from USDT only. When off there's no
// Naira wallet entry on the Wallet page, and utilities show a USDT balance instead
// of the NGN/USDT "Pay with" toggle. See NAIRA_WALLET_NOMBA.md §0.
export const NAIRA_WALLET_ENABLED = false;
export const DEFAULT_UTILITY_PAYMENT_SOURCE: "NGN" | "USDT" =
  NAIRA_WALLET_ENABLED ? "NGN" : "USDT";
